import type { IsReadFilter } from '@witmetrics/utils';
import { buildColumnFilter } from '@witmetrics/utils/filters';
import { COMPARISON_OPERATORS } from '@witmetrics/utils/constants';

export const CLEAR_READ_FILTER = buildColumnFilter(
  'isRead',
  COMPARISON_OPERATORS.IS.value,
  true
) as IsReadFilter;
